(function () {
  const REVEALED = "is-in";

  function revealAll(root) {
    root.querySelectorAll("[data-ct-tile]").forEach((tile) => tile.classList.add(REVEALED));
  }

  function setup(section) {
    if (section.dataset.ctBound === "true") return;
    section.dataset.ctBound = "true";

    const tiles = Array.from(section.querySelectorAll("[data-ct-tile]"));
    if (!tiles.length) return;

    const wantsReveal = section.dataset.reveal === "true";
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (!wantsReveal || reduceMotion || !("IntersectionObserver" in window)) {
      revealAll(section);
      return;
    }

    section.classList.add("ct--armed");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add(REVEALED);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -12% 0px", threshold: 0.12 }
    );

    tiles.forEach((tile) => observer.observe(tile));
  }

  function init(scope) {
    (scope || document).querySelectorAll(".ct").forEach(setup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  if (!window.ctEditorBound) {
    window.ctEditorBound = true;

    document.addEventListener("shopify:section:load", (event) => init(event.target));

    document.addEventListener("shopify:block:select", (event) => {
      const tile = event.target.closest("[data-ct-tile]");
      if (tile) tile.classList.add(REVEALED);
    });
  }
})();
